module.exports = __webpack_public_path__ + "img/img_index_banner_x4@2x.8213ad19.png";